import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { DropzoneArea } from 'material-ui-dropzone';
import { StyledButton } from '../../../Components/Generics.styled';

const UploadBackgroundImageContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const UploadAdInput = styled.div`
    min-height: 200px;
    margin-top: 16px;
    /* width: 500px; */
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;

    .MuiDropzonePreviewList-image {
        max-width: 400px;
        object-fit: cover;
        height: 250px;
        padding-bottom: 100px;
    }

    .MuiDropzonePreviewList-imageContainer {
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        max-width: none;
    }

    .MuiDropzoneArea-root {
        width: 100%;
        max-height: 400px;
        background-color: #fafbf7;
    }

    .MuiDropzoneArea-active {
        background-color: #2e69fe;
    }
`;

const ColorPickerApplet = styled.div`
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    /* width: 500px; */
    height: 100px;
    text-align: center;
`;

const ColorPicker = styled.input`
    height: 50px;
    width: 200px;
    padding: 0px;
    border-width: 0px;
    border-color: #fafbf7;
    background-color: #fafbf7;
    cursor: pointer;
`;

const UploadBackgroundImage = (props) => {
    const { handleNavButtonBack, handleNavButtonNext, setLeadGenerationData, leadGenerationData } =
        props;

    const [showPreview, setShowPreview] = useState(true);
    const handleFileUpload = (files) => {
        setShowPreview(true);
        setLeadGenerationData({
            ...leadGenerationData,

            backgroundImageFile: {
                ...leadGenerationData.backgroundImageFile,
                file: files[0],
            },
        });
    };

    const handleSolidBackgroundColorPicker = (e) => {
        setLeadGenerationData({
            ...leadGenerationData,
            theme: {
                ...leadGenerationData.theme,
                backgroundImageColor: e.target.value,
                backgroundImageSrc: '',
            },
            backgroundImageFile: {
                ...leadGenerationData.backgroundImageFile,
                file: undefined,
            },
        });
        setShowPreview(false);
    };

    useEffect(() => {
        if (leadGenerationData?.backgroundImageFile?.file) {
            setLeadGenerationData({
                ...leadGenerationData,
                theme: {
                    ...leadGenerationData.theme,
                    backgroundImageColor: '',
                },
            });
        }
    }, [leadGenerationData?.backgroundImageFile?.file]);

    return (
        <UploadBackgroundImageContainer>
            <Title>Upload a Background Image</Title>
            <UploadAdInput>
                <DropzoneArea
                    clearOnUnmount={false}
                    filesLimit={1}
                    maxFileSize={300000000}
                    initialFiles={
                        leadGenerationData?.backgroundImageFile?.file
                            ? [leadGenerationData.backgroundImageFile.file]
                            : []
                    }
                    acceptedFiles={['image/*']}
                    dropzoneText="Drag and drop your file here or click to upload."
                    onChange={(files) => handleFileUpload(files)}
                    showPreviewsInDropzone={showPreview}
                />
            </UploadAdInput>
            <div
                style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '80px',
                    fontSize: '23px',
                    fontWeight: 'bold',
                }}
            >
                Or
            </div>

            <Title>Select a Solid Backround Color</Title>
            <ColorPickerApplet>
                <ColorPicker
                    type="color"
                    value={leadGenerationData.theme.backgroundImageColor}
                    onChange={(e) => handleSolidBackgroundColorPicker(e)}
                />
            </ColorPickerApplet>

            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={
                        (leadGenerationData?.backgroundImageFile?.file === undefined ||
                            leadGenerationData?.backgroundImageFile?.file === null) &&
                        leadGenerationData.theme.backgroundImageColor === ''
                    }
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </UploadBackgroundImageContainer>
    );
};

UploadBackgroundImage.propTypes = {
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    leadGenerationData: propTypes.shape({
        theme: propTypes.shape({
            backgroundImageColor: propTypes.string,
            backgroundImageSrc: propTypes.string,
        }),
        backgroundImageFile: propTypes.shape({
            file: propTypes.shape({ name: propTypes.string }),
        }),
    }),
    setLeadGenerationData: propTypes.func,
};

UploadBackgroundImage.defaultProps = {
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    leadGenerationData: { backgroundImageFile: { file: {} } },
    setLeadGenerationData: () => {},
};
export default UploadBackgroundImage;
